<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyname"></comHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- データ入力エリア -->
        <v-card flat class="simple-table mx-auto">
          <v-row dense v-for="item in desserts" :key="item.name" class="border-row">
            <v-col cols="8" sm="8" lg="3" class="table-title d-flex justify-start align-center" >
              {{ item.name }}
            </v-col>
            <v-col cols="4" sm="4" lg="1" class="table-title-required d-flex justify-center align-center">
              <template v-if="item.requiredFlg" class="table-title-required">
                  <label class="tbl-lbl-blcok required"></label>
              </template>
              <template v-else class="table-title">
                <label class="tbl-lbl-blcok"></label>
              </template>
            </v-col>
            <v-col cols="12" sm="12" lg="8" class="table-td d-flex justify-start align-center pt-2 pb-0">
              <v-text-field label="" outlined :hint='item.hintChrs' dense :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval"></v-text-field>
              <!-- <v-text-field label="" :placeholder='item.placeholderChrs' dense solo hide-details="false" :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval"></v-text-field> -->
            </v-col>
          </v-row>
        </v-card>
        <!-- <v-simple-table class="simple-table">
          <template v-slot:default>
            <tbody>
              <tr v-for="item in desserts" :key="item.name">
                <td class="table-title" >{{ item.name }}</td>
                <td class="table-title-required">
                  <label class="tbl-lbl-blcok required"></label>
                </td>
                <td class="table-td-1">
                  <template>
                    <v-text-field label="" :placeholder='item.placeholderChrs' dense solo :type="item.pswdFlg ? 'password' : 'text'" v-model="item.inputval"></v-text-field>
                  </template>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->
        <br/>
        <!-- ボタンエリア -->
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" dark min-width="200px" @click="register()">変更</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" dark min-width="200px" @click="cancel()">キャンセル</v-btn>
          </v-col>
        </v-row>

      </v-container>
    </v-main>
    
    <!-- フッター(なし) -->

    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
  </div>
</template>


<script>
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "PwdChange",
  messageArea: "",
  data() {
    return {
      username: "",
      companyname: "",
      screenTitle: "パスワード変更",
      screenId: "MBC200",
      desserts: [
        { name: "現在のパスワード", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
        { name: "新しいパスワード", inputval: "", hintChrs: "パスワードは8文字以上で設定し、次の3種類以上の文字の種類を混在させてください。[英字大文字、英字小文字、数字、記号]", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
        { name: "新しいパスワード（確認）", inputval: "", placeholderChrs: "", pswdFlg: true, requiredFlg: true },
      ],
      pswdFlg: false,
      password: "Password",
      // rules: {
      //   required: (value) => !!value || "Required.",
      //   min: (v) => v.length >= 8 || "Min 8 characters",
      //   emailMatch: () => "The email and password you entered don't match",
      // },
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
          this.$router.push(this.$router.resolve({ name: "MBC110" }).href);
        },
      }
    };
  },
  created() {
    this.initialize();
  },
  methods : {
    /*
    * 初期表示
    */
    initialize: function () {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mbc200.area');
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setLoginInfoMixin();
      this.username = authInfo['username'];
      this.companyname = authInfo['companyname'];
    },
    /*
    * パスワード変更ボタン押下
    */
    register: async function () {
      // パスワード変更サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      try {
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        let loggedUserInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
        let apiurl = Constants.getUrlApiMBC200P01(loggedUserInfo['id']);
        // 入力データ
        let data = JSON.stringify(this.updateRequestData());
        // API呼出
        let response = await this.$axios.put(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},
              responseType: "json",
            }); 
        responseData = response.data;
        console.log(response);
      } catch(error) {
        apiErrorInfo = error;
      } finally {
        this.loading = false;
      }
      // 完了メッセージ表示 & 次画面遷移
      this.showDialogMsg(apiErrorInfo, responseData);
    },
    /*
    * キャンセルボタン押下
    */
    cancel: function() {
      this.$router.push(this.$router.resolve({ name: "MBC110", params: {srcScreenId: "MBR100"} }).href);
    },
    /*
    * 完了メッセージ表示
    */
    showDialogMsg : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm112', ['パスワード']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },
    
    /*
    * 変更用リクエストデータ生成
    */
    updateRequestData : function() {
      let reqData = {};
      for (const value of this.desserts) {
        switch (value.name) {
          case '現在のパスワード':
            reqData['nowPw'] = value.inputval;
            break;
          case '新しいパスワード':
            reqData['newPw'] = value.inputval;
            break;
          case '新しいパスワード（確認）':
            reqData['newPwConfirm'] = value.inputval;
            break;
        }
      }
      return reqData;
    },
  },
};
</script>

<style scoped>
.simple-table {
  table-layout: auto;
  width: 80%;
  margin: 40px 20px;
  margin-bottom: 0px;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td {
  background-color: #fff;
}
.table-td-1 {
  display: flex;
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
}

.border-row {
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #fff;
}

@media screen and (max-width: 750px) {
  .simple-table {
    table-layout: auto;
    width: 98%;
    margin: 3px 3px;
  }
  .table-title {
    background-color: #FFFFFF;
    width: 34%;
    font-size: 0.9em !important;
    text-align: left;
  }
  .table-title-required {
    background-color: #FFFFFF;
    width: 20%;
    text-align: right;
  }
  .table-td {
    background-color: #FFFFFF;
  }
}
</style>